import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Do I need a referral from my GP?",
    a: "No referral is needed. You can self-refer directly. We'll write to your GP with a summary of your assessment and plan if you'd like us to.",
  },
  {
    q: "Is this suitable if I've already had a fall?",
    a: "Absolutely — many of our clients come to us after a fall. We carefully assess the cause, then build a graded programme so you regain confidence without risking another incident.",
  },
  {
    q: "Are all sessions led by a chartered physiotherapist?",
    a: "Yes. Every assessment and programme at the Fall and Frailty Prevention Clinic is delivered or directly supervised by an HCPC- and CSP-registered chartered physiotherapist.",
  },
  {
    q: "What should I wear to my appointment?",
    a: "Comfortable, loose clothing you can move in — t-shirt and tracksuit-style trousers work perfectly. Supportive trainers, ideally lace-up.",
  },
  {
    q: "Do you accept private medical insurance?",
    a: "Yes — we work with some major insurers including WPA, Healix, Cigna. Please bring your authorisation code to your first appointment.",
  },
  {
    q: "How long is each session?",
    a: "Initial assessments are 60 minutes. Follow-up and programme sessions are typically 45 minutes. We never rush — that's the point.",
  },
  {
    q: "Where exactly are you based?",
    a: "Our clinic is at 29 Bromley Walk, Reading, RG30 4LR — with free parking and wheelchair-accessible entry. We serve clients from across Reading and Berkshire.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="py-20 md:py-32 px-6 md:px-12 bg-brand-cream"
      data-testid="faq-section"
    >
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta" data-testid="faq-eyebrow">
            Common questions
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-brand-blue mt-4 leading-tight" data-testid="faq-headline">
            Everything you&apos;d want to ask first.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {faqs.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="bg-white border border-brand-clay rounded-2xl px-6 md:px-8 data-[state=open]:border-brand-blue/40 data-[state=open]:shadow-sm"
            >
              <AccordionTrigger
                className="text-left font-display text-lg md:text-xl text-brand-blue py-5 hover:no-underline"
                data-testid={`faq-trigger-${idx + 1}`}
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-slate-700 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
